import { Identifier, useStore, useStoreResult } from 'react-admin';

const DefaultValue: Identifier[] = [];

export const useExpandedKeys = (
    key = 'ra-tree.expandedKeys',
    defaultValue: Identifier[] = DefaultValue
): useStoreResult<Identifier[]> => useStore<Identifier[]>(key, defaultValue);
